import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React from 'react'

import { Theme } from '../../lib/theming/Theme'

const useStyles = makeStyles<Theme>(theme => ({
  messageText: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    letterSpacing: '0.09375rem',
    lineHeight: '0.9375rem',
    marginBottom: '0.5rem',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
}))

const CountdownHeading = ({ message }: { message: string }) => {
  const classes = useStyles()

  return (
    <Typography className={classes.messageText} data-testid="countdown-display-message">
      {message}
    </Typography>
  )
}

export default CountdownHeading
